import { FaQuoteRight } from 'react-icons/fa6';
import styles from './styles.module.css'
import Star from '../Star';

const Card = (props) => {    
    
    const {reviewer,star,starNumber,companyName,datetime,review} = props;

    return (
        <div className='col-12 col-lg-6 mt-4'>
            <div className={`${styles['card']}`}>
                <div className='d-flex'>
                    <div className={styles['user']}>
                        <div className={`${styles['five-star']} mb-1 d-flex align-items-center`}>
                            {<Star /> }
                            <p className='mb-0 ms-1'>{star || ''}</p>       
                        </div>
                        <h3>{reviewer || ''}</h3>
                        <span>{companyName || ''}</span>                    
                    </div>
                    
                    <div className={styles['icon']}>
                        <FaQuoteRight size={50} color='rgba(255,80,1,0.8)' />    
                    </div>
                </div>
                <div className='mt-4'>
                    <p dangerouslySetInnerHTML={{__html:review}} />                        
                </div>
            </div>
        </div>
    );
};

export default Card;